import React from 'react';

function AboutHeroSection() {
  const styles = {
    section: {
      position: 'relative',
      width: '100%',
      backgroundColor: '#FFFFFF'
    },
    heroImage: {
      width: '100%',
      height: 'auto',
      display: 'block'
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',

      zIndex: 0.5
    },
    contentLayer: {
      position: 'absolute',
      inset: 0,
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column'
    },
    blackBanner: {
      width: '100%',
      maxWidth: 1920,
      height: 60,
      background: '#090909',
      opacity: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 clamp(24px, 5vw, 80px)',
      gap: 32,
      flexShrink: 0,
      zIndex: 2
    },
    bannerItem: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: '14px',
      color: '#FFFFFF',
      textDecoration: 'none'
    },
    bannerIcon: {
      width: 20,
      height: 20,
      objectFit: 'contain'
    },
    header: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '16px clamp(24px, 5vw, 80px)',
      flexWrap: 'wrap',
      gap: 16,
      background: '#FFFFFF',
      flexShrink: 0
    },
    logoWrap: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none'
    },
    logoImg: {
      height: 50,
      objectFit: 'contain',
      display: 'block'
    },
    nav: {
      display: 'flex',
      alignItems: 'center',
      gap: 32,
      flexWrap: 'wrap'
    },
    navLink: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: '16px',
      color: '#090909',
      textDecoration: 'none'
    },
    navBtn: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: '16px',
      padding: 0,
      background: 'transparent',
      color: '#090909',
      textDecoration: 'none',
      border: 'none',
      cursor: 'pointer',
      textTransform: 'none'
    },
    heroContent: {
      position: 'absolute',
      inset: 0,
      zIndex: 3,
      boxSizing: 'border-box',
      pointerEvents: 'none'
    },
    redPanelImg: {
      position: 'absolute',
      left: 'clamp(16px, 12vw, 250px)',
      top: '40%',
      transform: 'translateY(-50%)',
      width: 150,
      height: 'auto',
      display: 'block'
    },
    heroTitles: {
      position: 'absolute',
      top: '38%',
      left: 'clamp(24px, 13vw, 270px)',
      transform: 'translateY(-50%)',
      zIndex: 4,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 4  
    },
    title: {
      fontFamily: 'Lato',
      fontWeight: 600,
      fontSize: 'clamp(34px, 5vw, 56px)',
      lineHeight: 0.8,
      letterSpacing: '0.02em',
      color: '#FFFFFF',
      margin: 0,
      textTransform: 'uppercase'
    },
    tagline: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 'clamp(16px, 1.8vw, 22px)',
      lineHeight: 1.1,
      color: '#FFFFFF',
      margin: '16px 0 0 0',
      textTransform: 'uppercase'
    },
    taglineLine2: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 'clamp(16px, 1.8vw, 22px)',
      lineHeight: 1.1,
      color: '#FFFFFF',
      margin: '4px 0 0 0',
      textTransform: 'uppercase'
    },
    descriptionRule: {
      width: 150,
      height: 2,
      background: '#FFFFFF',
      margin: 0,
      flexShrink: 0
    },
    description: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: 'clamp(16px, 1.8vw, 20px)',
      lineHeight: 1.2,
      color: '#FFFFFF',
      margin: 0
    },
    aboutRightBlock: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      left: 'clamp(24px, 15vw, 300px)',
      maxWidth: 720,
      zIndex: 3,
      display: 'flex',
      alignItems: 'center',
      gap: 16
    }
  };

  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Services', href: '/services' },
    { label: 'Projects', href: '/#projects' },
    { label: 'Blogs', href: '/blogs' }
  ];

  var path = window.location.pathname;
  var hash = window.location.hash;
  function isActive(label) {
    if (label === 'Home') return path === '/' || path === '/index.html';
    if (label === 'About') return path.indexOf('/about') === 0;
    if (label === 'Services') return path.indexOf('/services') === 0;
    if (label === 'Projects') return hash === '#projects';
    if (label === 'Blogs') return path.indexOf('/blogs') === 0 || hash === '#blogs';
    return false;
  }

  return React.createElement('section', { style: styles.section },
    React.createElement('img', {
      src: '/AboutHero.png',
      alt: 'About Sunrise Infrabuild',
      style: styles.heroImage
    }),
    React.createElement('div', { style: styles.overlay }),
    React.createElement('div', { style: styles.contentLayer },
      React.createElement('div', { style: styles.blackBanner },
        React.createElement('a', { href: 'mailto:sunriseinfrajpr@gmail.com', style: styles.bannerItem },
          React.createElement('img', { src: '/MailIcon.png', alt: '', style: styles.bannerIcon }),
          'sunriseinfrajpr@gmail.com'
        ),
        React.createElement('a', { href: 'tel:+919790633555', style: styles.bannerItem },
          React.createElement('img', { src: '/PhoneIcon.png', alt: '', style: styles.bannerIcon }),
          '+91-9790633555'
        )
      ),
      React.createElement('header', { style: styles.header },
        React.createElement('a', { href: '/', style: styles.logoWrap },
          React.createElement('img', { src: '/SunRiseLogo.jpg', alt: 'Sunrise - Engineering our future', style: styles.logoImg })
        ),
        React.createElement('nav', { style: styles.nav },
          navItems.map(function (item, i) {
            return React.createElement('a', {
              key: i,
              href: item.href,
              style: styles.navLink,
              className: 'main-nav-link' + (isActive(item.label) ? ' main-nav-link-active' : '')
            }, item.label);
          }),
          React.createElement('a', { href: '/#contact', style: styles.navBtn, className: 'nav-btn-main' }, 'Contact Us')
        )
      )
    ),
    React.createElement('div', { style: styles.heroContent },
      React.createElement('img', {
        src: '/Red.png',
        alt: '',
        style: styles.redPanelImg
      }),
      React.createElement('div', { style: styles.heroTitles },
        React.createElement('h1', { style: styles.title }, 'ABOUT US'),
        React.createElement('p', { style: styles.tagline }, 'A LEGACY OF STRENGTH.'),
        React.createElement('p', { style: styles.taglineLine2 }, 'A FUTURE OF INNOVATION.')
      ),
      React.createElement('div', { style: styles.aboutRightBlock },
        React.createElement('div', { style: styles.descriptionRule }),
        React.createElement('p', { style: styles.description },
          'Sunrise Infrabuild Pvt Ltd is a leading piling and excavation company dedicated to building the backbone of modern infrastructure.'
        )
      )
    )
  );
}

export default AboutHeroSection;
